import React from 'react';

import { decodeUrlName, useSportsbookState, useSportState } from '@atlas/core';
import {
  DefaultCategoryRedirect,
  DefaultSportRedirect,
  SimplifiedSportRedirect,
} from '@atlas/routing';

export const CategoryRedirect = () => {
  const { categories, initialized } = useSportState();
  return (
    <DefaultCategoryRedirect
      categories={categories}
      decodeUrlName={decodeUrlName}
      initialized={initialized}
    />
  );
};

export const SportRedirect = () => {
  const { initialized, sports } = useSportsbookState();
  return <DefaultSportRedirect initialized={initialized} sports={sports} />;
};

export const SimplifiedRedirect = ({ selectedSportName }) => {
  const { initialized, sports } = useSportsbookState();

  return (
    <SimplifiedSportRedirect
      initialized={initialized}
      selectedSportName={selectedSportName}
      sports={sports}
    />
  );
};
